import { IRoute } from './App';
import dropbox from './assets/dropbox.svg';
import gdrive from './assets/googledrive.svg';
import mixcloud from './assets/mixcloud.svg';
import onedrive from './assets/onedrive.svg';
import soundcloud from './assets/soundcloud.svg';
import DropboxComponent from './components/dropbox/dropboxComponent';
import GoogleDriveComponent from './components/googleDrive/googleDriveComponent';
import Library from './components/library/libraryComponent';
import MixcloudComponent from './components/mixcloud/mixcloudComponent';
import OneDriveComponent from './components/oneDrive/oneDriveComponent';
import PodcastComponent from './components/podcasts/podcastComponent';
import SettingsComponent from './components/settingsAndStartup/settingsComponent';
import SoundCloudComponent from './components/soundCloud/soundCloudComponent';
import SpotifyComponent from './components/spotify/spotifyComponent';
import YouTubeComponent from './components/youTube/youTubeComponent';
import { mixcloudEnabled } from './services/mixcloud/mixcloudEnabled';
import { soundCloudEnabled } from './services/soundCloud/soundCloudEnabled';
import { spotifyEnabled } from './services/spotify/spotifyEnabled';

const routes: IRoute[] = [
  {
    name: 'Library',
    link: '/app/library',
    path: '/app/library/*',
    component: Library,
  },
  {
    name: 'YouTube',
    link: '/app/youtube',
    path: '/app/youtube/*',
    component: YouTubeComponent,
    icon: '/icons/yt_logo_rgb_light.png',
  },
  ...(soundCloudEnabled
    ? [
        {
          name: 'SoundCloud',
          path: '/app/soundcloud',
          component: SoundCloudComponent,
          icon: soundcloud,
          iconHeight: '0.6em',
        },
      ]
    : []),
  ...(mixcloudEnabled
    ? [
        {
          name: 'Mixcloud',
          path: '/app/mixcloud',
          component: MixcloudComponent,
          icon: mixcloud,
          iconHeight: '0.6em',
        },
      ]
    : []),
  ...(spotifyEnabled
    ? [
        {
          name: 'Spotify',
          path: '/app/spotify',
          component: SpotifyComponent,
          icon: '/icons/Spotify_Logo_RGB_Black.png',
        },
      ]
    : []),
  {
    name: 'OneDrive',
    link: '/app/onedrive',
    path: '/app/onedrive/*',
    component: OneDriveComponent,
    icon: onedrive,
  },
  {
    name: 'Google Drive',
    link: '/app/googleDrive',
    path: '/app/googleDrive/*',
    component: GoogleDriveComponent,
    icon: gdrive,
  },
  {
    name: 'Dropbox',
    link: '/app/dropbox',
    path: '/app/dropbox/*',
    component: DropboxComponent,
    icon: dropbox,
  },
  {
    name: 'Podcasts',
    path: '/app/podcasts',
    component: PodcastComponent,
    // icon: '/icons/podcast-icon-1322239_1280.png'
  },
  {
    name: 'Settings',
    path: '/app/settings',
    component: SettingsComponent,
  },
];

export default routes;
